module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#instagram",
      toString: function () {
        return this.url;
      }
    }